<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "divisions",
    item: null,
    fields: [
    ],
  }),
  props: ["id"],
  async created() {
    this.fields = [
      {
        label: "Предмет",
        key: "discipline",
        type: "select",
        selectKey: "title",
        modal: "business_discipline",
        prefix: "lessonplan_discipline",
        params: {}
      },
      {
        col: 'col-12 col-md-12',
        label: "Ученики",
        key: "clients",
        type: "clients",
        group_id: this.group_id
      }
    ];
    this.cardLink = `business/groups/${this.group_id}/divisions`;
    this.item = await this.cardContent(this.cardLink, this.division_id);
  },
  computed: {
    group_id() {
      return this.id.split("-")[1];
    },
    division_id() {
      return this.id.split("-")[0];
    },
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(this.cardLink, this.item, this.fields);

    },
  },
};
</script>
<style>
</style>
